import { useState, useEffect } from 'react';
import { useFormConditionalContext } from '../Conditional';
import { useFormContext } from '../Provider';

const useValidators = (val, validators, name, updateValidity, extraValidators) => {
    const [isValid, setIsValid] = useState(true);
    const [error, setError] = useState(null);
    const conditional = useFormConditionalContext();
    const {isValidating} = useFormContext();

    useEffect(() => {
        // Do nothing if the field isn't visible
        if (conditional && conditional.isVisible === false) {
            return;
        }

        const [newIsValid, newError] = validateValue(val, validators, extraValidators);

        if (newIsValid === isValid && newError === error) {
            return;
        }

        setIsValid(newIsValid);
        setError(newError);

        updateValidity(name, newIsValid);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [val, validators, conditional?.isVisible]);

    return {
        isValid,
        isInvalid: isValidating && !isValid,
        error
    };
}

const validateValue = (val, validators, extraValidators) => {
    let newIsValid = true, newErrors = [];

    const allValidators = [...(validators ?? []), ...(extraValidators ?? [])];

    for (let i = 0; i < allValidators.length; i++) {
        const [ valid, e ] = allValidators[i](val);

        if (valid === false) {
            newIsValid = false;
            newErrors.push(e);
        }
    }

    return [newIsValid, newErrors.filter((v, i) => newErrors.indexOf(v) === i).join(' ')];
}

export default useValidators;
